import React from 'react';
import { motion } from 'framer-motion';

const LoadingAnimation = ({ size = 80, className = '' }) => {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <motion.div
        className="relative"
        animate={{
          rotate: 360,
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "linear",
        }}
      >
        <img
          src="/logo.svg"
          alt="Loading..."
          width={size}
          height={size}
          className="drop-shadow-lg"
        />
      </motion.div>
      
      {/* Pulsing effect overlay */}
      <motion.div
        className="absolute"
        animate={{
          scale: [1, 1.2, 1],
          opacity: [0.7, 0.3, 0.7],
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        <img
          src="/logo.svg"
          alt=""
          width={size}
          height={size}
          className="opacity-30"
        />
      </motion.div>
    </div>
  );
};

export default LoadingAnimation;